import { useState, useEffect } from "react";
// import QrReader from "react-qr-reader";
import { useHistory } from "react-router-dom";
import firebase from "../firebase/firebase";
import { MyIcon, MyImg } from "../styles/styles";

// import scan from "../assets/scan.svg";
// import off from "../assets/off.svg";
// import plus from "../assets/plus.svg";
// import minus from "../assets/minus.svg";
// import triTop from "../assets/tri-top.svg";
// import triLeft from "../assets/tri-left.svg";
// import triRight from "../assets/tri-right.svg";
// import triBottom from "../assets/tri-bottom.svg";
// import remoteBottom from "../assets/remote-bottom.png";
// import texture from "../assets/texture.png";
// import textureDark from "../assets/texture-dark.png";

import top_area from "../assets/remote/top-area.png";
import bottom_area from "../assets/remote/bottom-area.png";
import power from "../assets/remote/power.png";
import sync from "../assets/remote/sync.png";
import volume from "../assets/remote/volume.png";
import guide from "../assets/remote/guide.png";
import channel from "../assets/remote/channel.png";
import arrow_left from "../assets/remote/arrow-left.png";
import arrow_up from "../assets/remote/arrow-up.png";
import arrow_right from "../assets/remote/arrow-right.png";
import arrow_down from "../assets/remote/arrow-down.png";
import ok from "../assets/remote/ok.png";
import num_0 from "../assets/remote/num-0.png";
import num_1 from "../assets/remote/num-1.png";
import num_2 from "../assets/remote/num-2.png";
import num_3 from "../assets/remote/num-3.png";
import num_4 from "../assets/remote/num-4.png";
import num_5 from "../assets/remote/num-5.png";
import num_6 from "../assets/remote/num-6.png";
import num_7 from "../assets/remote/num-7.png";
import num_8 from "../assets/remote/num-8.png";
import num_9 from "../assets/remote/num-9.png";

const getQueryParams = () =>
  window.location.search
    .replace("?", "")
    .split("&")
    .reduce(
      (r, e) => ((r[e.split("=")[0]] = decodeURIComponent(e.split("=")[1])), r),
      {}
    );

const getQrcode = (tempUrl) => {
  if (tempUrl) {
    return tempUrl.split("?")[1].split("=")[1];
  } else {
    return null;
  }
};

const RemoteApp = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(true); // IMP  byDefault should be true

  const [wait, setWait] = useState(false);
  // const [qrcodeScanned, setQrcodeScanned] = useState(false); // IMP  byDefault should be false
  const [qrcodeValue, setQrcodeValue] = useState("");

  const [channelNo, setChannelNo] = useState(null);

  const handleRemoteScan = () => {
    if (window.location.search) {
      const queryParams = getQueryParams();
      const qrcode = queryParams?.qrcode;
      if (qrcode) {
        handleScan(qrcode);
      }
    }
  };

  useEffect(() => {
    handleRemoteScan();
  }, []);

  // START scan
  const handleScan = async (qrcode) => {
    setLoading(true);
    setQrcodeValue(qrcode);
    try {
      await firebase.firestore().collection("tv_remote").doc(qrcode).update({
        channel_no: 1,
        scanned: true,
      });

      setTimeout(async () => {
        await firebase
          .firestore()
          .collection("tv_remote")
          .doc(qrcode)
          .update({ scanned: false });

        setLoading(false);
      }, 1000);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleOnAppScan = (data) => {
    if (!data) return;
    const qrcode = getQrcode(data);
    handleScan(qrcode);
  };

  const handleError = (err) => {
    console.log(err);
  };
  // END Scan

  const handleUpdateChannelNo = async (no) => {
    try {
      await firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ channel_no: no });

      setChannelNo(null);
      setWait(false);
    } catch (error) {
      setChannelNo(null);
      setWait(false);
    }
  };

  // PART Remote buttons
  const handleResetScan = async () => {
    try {
      await firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ remote_linked: null, scanned: false, control_key: null });

      setQrcodeValue("");
      // setQrcodeScanned(false);
      history.replace("/");
    } catch (error) {
      setQrcodeValue("");
      history.replace("/");
      // setQrcodeScanned(false);
    }
  };

  const handlePowerOff = async () => {
    try {
      await firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ remote_linked: null, scanned: false, control_key: "OFF" });

      setQrcodeValue("");
      // setQrcodeScanned(false);
      history.replace("/");
    } catch (error) {
      setQrcodeValue("");
      // setQrcodeScanned(false);
      history.replace("/");
    }
  };

  // Number Pad buttons
  const handleNoClick = (no) => {
    // if (!qrcodeScanned) return;

    const newNo = channelNo ? channelNo + no : no;
    setChannelNo(newNo);

    setTimeout(() => {
      handleUpdateChannelNo(newNo);
    }, 1500);
  };

  const handlePlusMinusChannel = (type) => {
    // if (!qrcodeScanned || wait) return;
    if (wait) return;

    setWait(true);
    firebase
      .firestore()
      .collection("tv_remote")
      .doc(qrcodeValue)
      .get()
      .then((docSnap) => {
        if (docSnap.exists) {
          const { channel_no } = docSnap.data();

          if (type === "plus") {
            const newNo = Number(channel_no) + 1;
            setChannelNo(newNo);
            handleUpdateChannelNo(newNo);
          } else if (type === "minus") {
            const newNo = Number(channel_no) - 1;
            if (newNo === 0) return;

            setChannelNo(newNo);
            handleUpdateChannelNo(newNo);
          }
        }
      })
      .catch((err) => {
        setWait(false);
        console.log(err);
      });
  };

  // Control Buttons
  const handleControlKey = async (type) => {
    try {
      await firebase
        .firestore()
        .collection("tv_remote")
        .doc(qrcodeValue)
        .update({ control_key: type });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section>
      <div className="gif-remote">
        {/* {qrcodeScanned ? ( */}
        {loading ? (
          <div className="py-5 text-center">
            <h5>Please wait...</h5>
          </div>
        ) : (
          <div className="remote-cover">
            <MyImg src={top_area} alt="top" width="100%" />
            <div className="px-5">
              <div className="d-flex justify-content-between mx-2">
                <div className="text-center">
                  <p className="romote_title">POWER</p>
                  <span onClick={handlePowerOff} role="button">
                    <MyImg src={power} alt="power" width="50px" height="50px" />
                  </span>
                </div>
                <div className="text-center">
                  <p className="romote_title">SYNC</p>
                  <span onClick={handleResetScan} role="button">
                    <MyImg src={sync} alt="sync" width="40px" height="40px" />
                  </span>
                </div>
              </div>
              {/* VOLUME GUIDE CHANNEL */}
              <div className="mt-2">
                <div className="d-flex justify-content-between">
                  <div className="position-relative">
                    <MyImg src={volume} width="55px" />
                    <div
                      onClick={() => handleControlKey("VOL_UP")}
                      role="button"
                      className="remote_overlay_btn btn_pos--up"
                    />
                    <div
                      onClick={() => handleControlKey("VOL_DOWN")}
                      role="button"
                      className="remote_overlay_btn btn_pos--down"
                    />
                  </div>
                  <span
                    onClick={() => handleControlKey("GUIDE")}
                    role="button"
                    style={{ marginTop: "-14px" }}
                  >
                    <MyImg src={guide} width="100px" height="45px" />
                  </span>
                  <div className="position-relative">
                    <MyImg src={channel} width="55px" />
                    <div
                      onClick={() => handlePlusMinusChannel("plus")}
                      role="button"
                      className="remote_overlay_btn btn_pos--up"
                    />
                    <div
                      onClick={() => handlePlusMinusChannel("minus")}
                      role="button"
                      className="remote_overlay_btn btn_pos--down"
                    />
                  </div>
                </div>
              </div>
              {/* Arrow OKAY */}
              <div style={{ marginTop: "-60px" }}>
                <div className="d-flex align-items-center justify-content-center">
                  <span
                    onClick={() => handleControlKey("VOL_DOWN")}
                    role="button"
                    className="remote_arrow--left"
                  >
                    <MyImg src={arrow_left} width="55px" height="40px" />
                  </span>
                  <div className="d-flex flex-column align-items-center">
                    <div
                      onClick={() => handleControlKey("GUIDE_UP")}
                      role="button"
                      className="remote_arrow--top"
                    >
                      <MyImg src={arrow_up} width="40px" height="55px" />
                    </div>
                    <div
                      onClick={() => handleControlKey("GUIDE_OK")}
                      role="button"
                      className="remote_ok--center"
                    >
                      <MyImg src={ok} width="45px" height="45px" />
                    </div>
                    <div
                      onClick={() => handleControlKey("GUIDE_DOWN")}
                      role="button"
                      className="remote_arrow--bottom"
                    >
                      <MyImg src={arrow_down} width="40px" height="55px" />
                    </div>
                  </div>
                  <span
                    onClick={() => handleControlKey("VOL_UP")}
                    role="button"
                    className="remote_arrow--right"
                  >
                    <MyImg src={arrow_right} width="55px" height="40px" />
                  </span>
                </div>
              </div>
              {/* NUMBERS */}
              <div className="mx-5 my-2">
                <div className="d-flex align-items-center justify-content-center">
                  <span
                    onClick={() => handleNoClick("1")}
                    role="button"
                    className="remote_num--cover"
                  >
                    <MyImg src={num_1} alt="num" width="40px" height="40px" />
                  </span>
                  <span
                    onClick={() => handleNoClick("2")}
                    role="button"
                    className="mx-3 remote_num--cover"
                  >
                    <MyImg src={num_2} alt="num" width="40px" height="40px" />
                  </span>
                  <span
                    onClick={() => handleNoClick("3")}
                    role="button"
                    className="remote_num--cover"
                  >
                    <MyImg src={num_3} alt="num" width="40px" height="40px" />
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <span
                    onClick={() => handleNoClick("4")}
                    role="button"
                    className="remote_num--cover"
                  >
                    <MyImg src={num_4} alt="num" width="40px" height="40px" />
                  </span>
                  <span
                    onClick={() => handleNoClick("5")}
                    role="button"
                    className="mx-3 remote_num--cover"
                  >
                    <MyImg src={num_5} alt="num" width="40px" height="40px" />
                  </span>
                  <span
                    onClick={() => handleNoClick("6")}
                    role="button"
                    className="remote_num--cover"
                  >
                    <MyImg src={num_6} alt="num" width="40px" height="40px" />
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <span
                    onClick={() => handleNoClick("7")}
                    role="button"
                    className="remote_num--cover"
                  >
                    <MyImg src={num_7} alt="num" width="40px" height="40px" />
                  </span>
                  <span
                    onClick={() => handleNoClick("8")}
                    role="button"
                    className="mx-3 remote_num--cover"
                  >
                    <MyImg src={num_8} alt="num" width="40px" height="40px" />
                  </span>
                  <span
                    onClick={() => handleNoClick("9")}
                    role="button"
                    className="remote_num--cover"
                  >
                    <MyImg src={num_9} alt="num" width="40px" height="40px" />
                  </span>
                </div>
                <div className="d-flex align-items-center justify-content-center">
                  <span
                    onClick={() => handleNoClick("0")}
                    role="button"
                    className="remote_num--cover"
                  >
                    <MyImg src={num_0} alt="num" width="40px" height="40px" />
                  </span>
                </div>
              </div>
            </div>
            <MyImg src={bottom_area} alt="bottom" width="100%" />
            {channelNo && <div className="channel-no">{`CH ${channelNo}`}</div>}
          </div>
        )}
      </div>
    </section>
  );
};

export default RemoteApp;

/*

<div style={{ background: `url(${texture})` }} className="remote">
              <div
                style={{ background: `url(${textureDark})` }}
                className="d-flex align-items-center p-4"
              >
                <div onClick={handlePowerOff}>
                  <MyIcon src={off} alt="off" w="12vw" h="6vh" />
                </div>
                <div onClick={handleResetScan} className="ms-2">
                  <MyIcon src={scan} alt="scan" w="8vw" h="5vh" />
                </div>
              </div>
              <div className="white-space mt-2" />
              <div className="d-flex align-items-center justify-content-between px-4 py-3">
                <div className="text-center">
                  <p className="title">VOL</p>
                  <div
                    onClick={() => handleControlKey("VOL_UP")}
                    className="number"
                  >
                    <MyIcon src={plus} alt="plus" w="15px" h="15px" />
                  </div>
                  <div
                    onClick={() => handleControlKey("VOL_DOWN")}
                    className="number"
                  >
                    <MyIcon src={minus} alt="minus" w="15px" h="4px" />
                  </div>
                </div>
                <div className="nav-control">
                  <div
                    onClick={() => handleControlKey("GUIDE_UP")}
                    className="arrow top mx-auto"
                  >
                    <MyIcon src={triTop} alt="arrow" w="16px" h="22px" />
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div
                      onClick={() => handleControlKey("VOL_DOWN")}
                      className="arrow left"
                    >
                      <MyIcon src={triLeft} alt="arrow" w="20px" h="14px" />
                    </div>
                    <div
                      onClick={() => handleControlKey("GUIDE_OK")}
                      className="ok"
                    >
                      <p>OK</p>
                    </div>
                    <div
                      onClick={() => handleControlKey("VOL_UP")}
                      className="arrow right"
                    >
                      <MyIcon src={triRight} alt="arrow" w="20px" h="14px" />
                    </div>
                  </div>
                  <div
                    onClick={() => handleControlKey("GUIDE_DOWN")}
                    className="arrow bottom mx-auto"
                  >
                    <MyIcon src={triBottom} alt="arrow" w="16px" h="22px" />
                  </div>
                </div>
                <div className="text-center">
                  <p className="title">CH</p>
                  <div
                    onClick={() => handlePlusMinusChannel("plus")}
                    className="number"
                  >
                    <MyIcon src={plus} alt="plus" w="15px" h="15px" />
                  </div>
                  <div
                    onClick={() => handlePlusMinusChannel("minus")}
                    className="number"
                  >
                    <MyIcon src={minus} alt="minus" w="15px" h="4px" />
                  </div>
                </div>
              </div>
              <div
                onClick={() => handleControlKey("GUIDE")}
                className="guide mx-auto"
              >
                <p>TV GUIDE</p>
              </div>
              <div className="mx-5 px-5">
                <div className="d-flex align-items-center justify-content-between mx-3">
                  <div onClick={() => handleNoClick("1")} className="number">
                    <p>1</p>
                  </div>
                  <div onClick={() => handleNoClick("2")} className="number">
                    <p>2</p>
                  </div>
                  <div onClick={() => handleNoClick("3")} className="number">
                    <p>3</p>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mx-3">
                  <div onClick={() => handleNoClick("4")} className="number">
                    <p>4</p>
                  </div>
                  <div onClick={() => handleNoClick("5")} className="number">
                    <p>5</p>
                  </div>
                  <div onClick={() => handleNoClick("6")} className="number">
                    <p>6</p>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between mx-3">
                  <div onClick={() => handleNoClick("7")} className="number">
                    <p>7</p>
                  </div>
                  <div onClick={() => handleNoClick("8")} className="number">
                    <p>8</p>
                  </div>
                  <div onClick={() => handleNoClick("9")} className="number">
                    <p>9</p>
                  </div>
                </div>
                <div
                  onClick={() => handleNoClick("0")}
                  className="number mx-auto"
                >
                  <p>0</p>
                </div>
              </div>
              <MyIcon src={remoteBottom} w="100vw" />
            </div>
            

*/
